// extracted by mini-css-extract-plugin
export default {"TaskFormWrapper":"TaskForm_TaskFormWrapper__jAzHR","Table":"TaskForm_Table__FkYOd","Section":"TaskForm_Section__65VKL"};